import Sitemap from "../components/Sitemap";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

// helpers
import {
  apiHelper,apiHelperBlockchain ,apiHelperWordpressForNews } from "../helper/apiHelper";


export default function Sitemaps(props) {
  return (
    <Sitemap {...props}/>
  );
}

export const getStaticProps = async ({ locale }, ctx) => {
  const pageName = "sitemap";
  const postData = {
    language: locale,
    pageName: pageName,
  };
  if (locale === "default") {
    locale = "en";
  }
 
  const resMeta = await apiHelper(`metadata/getNftMetadata`,"POST",postData,null);
  let meta = resMeta.data.status ? resMeta.data.data : null;

  const resCatList = await apiHelperBlockchain(`category-list`,"GET",null,null);
  const catList = resCatList.data.status ? resCatList.data.data : null;

  const resNewsList = await apiHelperBlockchain(`/v2/news-sitemap?language=${locale}`,"GET",null,null,true);
  const newsList = resNewsList.data.status ? resNewsList?.data?.data : null;

  const resNewsTag = await apiHelperBlockchain(`/v2/news-tags?locale=${locale}`,"GET",null,null,true);
  const newsTags = resNewsTag.data.status ? resNewsTag.data.data : null;

 const GetEventsCategoriesQuery = `query NewQuery {
    ${locale === 'en' ?'allEventCategoriesEN' : 'allEventCategoriesAR'} {
      nodes {
        name
        id
        slug
        mainContentOfCategory {
          titleH1
        }
      }
    }
  }`
  const resEventList = await apiHelperWordpressForNews(GetEventsCategoriesQuery);
  const EventData = (locale === 'en' ? resEventList.data.data.allEventCategoriesEN : resEventList.data.data.allEventCategoriesAR).nodes;
  
  const GetBlogCategoriesQuery = `query NewQuery {
      ${locale === 'en' ?'allBlogCategoriesEN' : 'allBlogCategoriesAR'} {
        nodes {
          slug
          name
          id
          mainContentOfCategory {
            titleH1
          }
        }
      }
    }`

    const resBlogCategoryList = await apiHelperWordpressForNews(GetBlogCategoriesQuery);
    const BlogCategoryData = (locale === 'en' ? resBlogCategoryList.data.data.allBlogCategoriesEN : resBlogCategoryList.data.data.allBlogCategoriesAR).nodes;

    const getTotalPostsQuery =`query NewQuery {
      ${locale === 'en' ?'allBlogEN' : 'allBlogAR'}(first:500){
          nodes {
            id
            slug
            title
          }
          
        }
      }`
    
      const resBlogList = await apiHelperWordpressForNews(getTotalPostsQuery);
      const BlogData = (locale === 'en' ? resBlogList.data.data.allBlogEN : resBlogList.data.data.allBlogAR).nodes;
    
  
  const canonical = process.env.hostBaseUrl + "/" + locale + "/" + pageName;

  return {
    props: {
      meta,
      currLocale: locale,
      catList,
      newsList,
      newsTags,
      EventData,
      BlogData,
      BlogCategoryData,
      ogImage: 'nft-marketplace-en-social.png',
      canonical,
      dynamicURL: "/" + pageName,
      pageName: locale === "en" ? "UPYO Sitemap" : "خريطة موقع UPYO",
      ...(await serverSideTranslations(locale, ["common"])),
    },
    revalidate: 10, // In seconds
  };
};
